import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { createPortal } from "react-dom"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"
import Deposit from "../transactions/Deposit"
import LoginGlobal from "../data/LoginGlobal"

export default function RecoveryBonus() {
  const data = promotionsData.find(
    (promo) => promo.title === "8PM RECOVERY HOUR"
  )
  const [isMobile, setIsMobile] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [isDepositOpen, setIsDepositOpen] = useState(false)

  useEffect(() => {
    const loggedInState = localStorage.getItem("isLoggedIn") === "true"
    setIsLoggedIn(loggedInState)
  }, [])

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  useEffect(() => {
    if (!isDepositOpen) return
    const prev = document.body.style.overflow
    document.body.style.overflow = "hidden"
    return () => {
      document.body.style.overflow = prev
    }
  }, [isDepositOpen])

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title> 8PM RECOVERY HOUR </title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a href="/promotion/">Promotion</a> / <span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />
            </div>
            <div className="promotion-tnc-content">
              <div className="promotion-tnc-info">
                <div
                  className={`promotion-indication-message ${data.promotionMessage.class}`}
                >
                  {data.promotionMessage.text}
                </div>
                <h1> 8PM Recovery Hour </h1>
                <h2> Recover & Play Now </h2>
                <div className="promotion-tnc-period">
                  <strong> Promo Period: </strong>
                  <span> November 10 - December 10, 2025 </span>
                </div>
              </div>
              <div className="promotion-tnc-mechanic-content">
                <strong> Mechanics: </strong>
                <ol>
                  <li>
                    <strong className="highlight">
                      Deposit ₱250 or more only between 8PM-9PM.{" "}
                    </strong>

                    <ul style={{ marginBottom: "0px" }}>
                      <li>
                        <p>Play until your balance reaches ₱9 or less.</p>
                      </li>
                      <li>
                        <p>
                          <strong className="highlight">
                            No withdrawals must be made after the deposit from
                            8PM-9PM.{" "}
                          </strong>
                        </p>
                      </li>
                      <li>
                        ❗ Deposits made before or after 8PM–9PM will NOT
                        qualify.
                      </li>
                      <li>
                        ❗ Loss outside the 8PM–9PM window will NOT qualify.
                      </li>
                      <li>
                        Once these conditions are met:
                        <ul style={{ marginBottom: "0px" }}>
                          <li>
                            ✅ You’ll unlock a 8% bonus on your next deposit
                            within 8PM-9PM.
                          </li>
                          <li>
                            ✅ Next deposit must be ₱250 or more (required
                            minimum deposit).
                          </li>
                          <li>
                            ✅ However, the 8% bonus will still be calculated
                            based on your most recent lost deposit amount(within
                            the same 8-9PM window).
                          </li>
                          <li>
                            ❗ Next deposits made after 9PM will NOT receive the
                            bonus.
                          </li>
                          <li>
                            ❗ Bonus is only claimable within the same 8–9PM
                            session.
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <strong className="highlight">
                      Bonus Calculation Based on Lost Deposit:
                    </strong>
                    <ul style={{ marginBottom: "0px" }}>
                      <li>
                        Deposit ₱500 at 8PM → lose it at 8:15PM → Next deposit
                        ₱250 at 8:20PM → +8% bonus (of the ₱500) = ₱40{" "}
                        <strong className="highlight">
                          {" "}
                          → Total Starting Balance: ₱290{" "}
                        </strong>
                      </li>
                      <li>
                        Deposit ₱250 at 8:30PM → lose it at 8:35PM → Next
                        deposit ₱500 at 8:55PM → +8% bonus (of the ₱250) = ₱20{" "}
                        <strong className="highlight">
                          {" "}
                          → Total Starting Balance: ₱520{" "}
                        </strong>
                      </li>
                      <li>
                        Deposit ₱10,000 → lose it →{" "}
                        <strong className="highlight">
                          {" "}
                          Bonus capped at ₱2,500.{" "}
                        </strong>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <strong className="highlight">
                      Withdrawals Cancel Bonus Eligibility:{" "}
                    </strong>
                    <p>
                      If you made a withdrawal after receiving the 8% Recovery
                      Bonus, you won't be eligible for the next one right away.
                    </p>
                    <ul style={{ liststyleType: "none", marginBottom: "0px" }}>
                      <p>
                        <strong className="highlight">
                          {" "}
                          To qualify again:{" "}
                        </strong>
                      </p>
                      <li>✅ Make a new deposit. (8-9PM)</li>
                      <li>✅ Play until your balance is ₱9 or less.(8-9PM)</li>
                      <li>✅ No withdrawal record after the deposit.</li>
                    </ul>
                  </li>
                </ol>
                <strong> Terms and Conditions: </strong>
                <ul>
                  <li>
                    All qualifying actions (deposit, loss, next deposit) must
                    occur strictly within 8PM–9PM daily
                  </li>
                  <li>✅ Minimum qualifying deposit: ₱250.</li>
                  <li>✅ Maximum bonus per deposit: ₱2,500.</li>
                  <li>
                    ✅ Recovery Bonus is only granted if{" "}
                    <strong className="highlight"> No Withdrawal </strong> was
                    made after a lost deposit.
                  </li>
                  <li>
                    ✅ The next deposit must be{" "}
                    <strong className="highlight">
                      {" "}
                      ₱250 or more, and the bonus will be based on the most
                      recent lost deposit with no withdrawal within 8PM-9PM.{" "}
                    </strong>
                  </li>
                  <li>
                    ✅ Recovery Bonus can be availed{" "}
                    <strong className="highlight">
                      {" "}
                      Multiple Times during the promo period,{" "}
                    </strong>{" "}
                    provided conditions are met.
                  </li>
                  <li>✅ Valid for all games.</li>
                  <li>
                    ✅{" "}
                    <strong className="highlight">
                      {" "}
                      Rollover Requirement:{" "}
                    </strong>{" "}
                    1x of Deposit + 1x of Bonus before withdrawal.
                  </li>
                  <li>
                    ✅ FGH reserves the right to modify, suspend, or cancel the
                    promotion at any time.
                  </li>
                </ul>

                <div className="promotion-tnc-cta">
                  {isLoggedIn ? (
                    <button
                      type="button"
                      className="promotion-cta-btn"
                      style={{ cursor: "pointer" }}
                      onClick={() => setIsDepositOpen(true)}
                    >
                      Deposit Now
                    </button>
                  ) : (
                    <LoginGlobal
                      label="Deposit Now"
                      btnClass="promotion-cta-btn"
                      onlyBtn={true}
                    />
                  )}
                </div>
                {isDepositOpen &&
                  createPortal(
                    <div className="modal-portal">
                      <Deposit
                        onClose={() => setIsDepositOpen(false)}
                        defaultBonusName="New Member Package Bonus"
                      />
                    </div>,
                    document.body
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
